import React from "react";
import "../../../css/Tramites/licencia-conducir.css";

const pdfs = [
  {
    label: "Descargar Instructivo de Motocicletas",
    url:  "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/instructivo/Manual-MOTOS.pdf",
  },
  {
    label: "Descargar Instructivo de Automóviles",
    url: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/instructivo//Manual-AUTOS.pdf",
  },
];

const LicenciaConducir = () => (
  <div className="licencia-full-bg">
    <div className="licencia-container">
      <h1>Licencia de Conducir</h1>

      <section className="licencia-section">
        <h2>Documentación necesaria para obtener licencia de conducir</h2>
        <ul>
          <li>Copia del DNI.</li>
          <li>Copia de cédula verde. DNI titular.</li>
          <li>Copia del seguro.</li>
          <li>La licencia anterior o denuncia.</li>
          <li>Curso.</li>
        </ul>
        <h3>Clase “D”, “E” y “C”</h3>
        <ul>
          <li>
            Certificado de antecedentes penales (AFIP, clave fiscal, Registro
            Nacional de Reincidencia, Mi Argentina)
          </li>
          <li>Apto psicológico</li>
          <li>Copia del DNI</li>
          <li>Copia de cédula verde. DNI titular.</li>
          <li>Copia del seguro.</li>
          <li>La licencia anterior o denuncia.</li>
        </ul>
        <h3>Renovación “A”, “B” y “G”</h3>
        <ul>
          <li>Copia del DNI.</li>
          <li>La licencia anterior o denuncia.</li>
        </ul>
        <p className="licencia-curso">
          Realizar <b>Curso obligatorio de Educación Vial</b> para obtener la
          Licencia Nacional de Conducir de forma totalmente online y gratuita,
          el mismo se puede realizar de manera digital desde la{" "}
          <a
            href="https://curso.seguridadvial.gob.ar/ansv/"
            target="_blank"
            rel="noopener noreferrer"
          >
            página web.
          </a>
        </p>
        <div className="licencia-botones">
          {pdfs.map((pdf, i) => (
            <a
              key={i}
              href={pdf.url}
              className="licencia-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              {pdf.label}
            </a>
          ))}
        </div>
      </section>

      <section className="licencia-section">
        <h2>Categorías</h2>
        <div className="licencia-categorias">
          <div>
            <b>Clase A-1:</b>
            <ul>
              <li>
                Ciclomotores hasta 50cc. Edad mínima 16 años con autorización de
                padre, madre o tutor.
              </li>
            </ul>
          </div>
          <div>
            <b>Clase A-2:</b>
            <ul>
              <li>
                Motos, triciclos y cuadriciclos de 51cc a 150cc. Edad mínima 18
                años.
              </li>
            </ul>
          </div>
          <div>
            <b>Clase A-3:</b>
            <ul>
              <li>
                Motos, triciclos y cuadriciclos de más de 150cc. Edad mínima 18
                años.
              </li>
            </ul>
          </div>
          <div>
            <b>Clase B-1:</b>
            <ul>
              <li>
                Automóviles, camionetas y casas rodantes hasta 3.500 kg y hasta
                9 plazas. Edad mínima 18 años.
              </li>
            </ul>
          </div>
          <div>
            <b>Clase B-2:</b>
            <ul>
              <li>
                Automóviles y camionetas con remolque hasta 750 kg, hasta 3.500
                kg. Requiere B-1 con 1 año de antigüedad.
              </li>
            </ul>
          </div>
          <div>
            <b>Clase C:</b>
            <ul>
              <li>
                Camiones sin acoplado y casas rodantes de más de 3.500 kg.
                Requiere B-1 con 1 año de antigüedad.
              </li>
            </ul>
          </div>
          <div>
            <b>Clase D-1 a D-4:</b>
            <ul>
              <li>
                Transporte de pasajeros, servicios de emergencia y policía.
                Requiere B-1 con 1 año de antigüedad.
              </li>
            </ul>
          </div>
          <div>
            <b>Clase E-1 y E-2:</b>
            <ul>
              <li>
                Camiones y vehículos articulados para transporte de cosas.
                Requiere B-1 con 1 año de antigüedad.
              </li>
            </ul>
          </div>
          <div>
            <b>Clase F:</b>
            <ul>
              <li>
                Vehículos adaptados por discapacidad. Edad mínima 18 años.
              </li>
            </ul>
          </div>
          <div>
            <b>Clase G:</b>
            <ul>
              <li>
                Tractores y maquinaria agrícola. Requiere B-1 con 1 año de
                antigüedad.
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="licencia-section">
        <h2>Vigencia de las Licencias de Conducir</h2>
        <p>
          Las licencias otorgadas por la Municipalidad de Oliva tienen vigencia
          de <b>2 años</b>, excepto para quienes la obtienen por primera vez y
          mayores de 70 años, que es de <b>1 año</b>.
        </p>
      </section>

      <section className="licencia-section">
        <h2>Licencia de Conducir por primera vez</h2>
        <ul>
          <li>Aprobar el Examen Teórico.</li>
          <li>
            Obtener la Constancia de Antecedentes del RePAT y del Juzgado de
            Faltas de la Municipalidad de Oliva.
          </li>
          <li>Realizar el examen Psicofísico.</li>
          <li>Declaración Jurada de Salud.</li>
          <li>Exámenes Varios.</li>
          <li>Aprobar el Examen Práctico.</li>
          <li>Provisión de la Licencia de Conducir.</li>
          <li>Previa Registración en el RePAT con su código de seguridad.</li>
          <li>Documento Nacional de Identidad y copia del mismo.</li>
        </ul>
      </section>

      <section className="licencia-section">
        <h2>Renovación de Licencia de Conducir</h2>
        <ul>
          <li>Obtener la Constancia de Antecedentes del RePAT.</li>
          <li>Declaración Jurada de Salud.</li>
          <li>Exámenes Varios.</li>
          <li>Aprobar el Examen Práctico.</li>
          <li>Provisión de la Licencia de Conducir.</li>
          <li>Previa Registración en el RePAT con su código de seguridad.</li>
          <li>Documento Nacional de Identidad y copia del mismo.</li>
        </ul>
      </section>

      <section className="licencia-section">
        <h2>Requisitos especiales</h2>
        <p>
          Para conductores profesionales, además de los requisitos generales, se
          debe presentar <b>sin excepción</b> el Certificado de Antecedentes
          Penales, que puede tramitarse en la Policía de Córdoba o el Registro
          Nacional de Reincidencia.
        </p>
      </section>
    </div>
  </div>
);

export default LicenciaConducir;
